import React from 'react';
import { Reveal } from './Reveal';
const items = [{
  title: 'Flexibilidad',
  text: 'Part-time o full-time.'
}, {
  title: 'Capacitación',
  text: 'Aprende desde cero.'
}, {
  title: 'Crecimiento por resultados',
  text: 'Tu desarrollo depende de tu desempeño.'
}];
export function Benefits() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-40" aria-label="Beneficios" data-id="element-14" data-mp="3vppa289dx65j">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-15" data-mp="3qsf8ju8q141c">
        <div className="grid grid-cols-1 border-t border-ink/15 md:grid-cols-3" data-id="element-16" data-mp="3mpizau52mka2">
          {items.map((item, i) => <Reveal key={item.title} delay={i * 0.08} className={`border-b border-ink/12 md:border-b-0 md:border-r md:last:border-r-0 ${i > 0 ? 'md:pl-10' : ''} ${i < items.length - 1 ? 'md:pr-10' : ''}`} data-id="element-17" data-mp="3hs0n8uvrboxu" data-mpi={i}>
              <div className="py-10 md:py-12" data-id="element-18" data-mp="1b084ze9ic9jt">
                <h3 className="font-sans text-sm font-medium uppercase tracking-[0.2em] text-ink" data-id="element-19" data-mp="1ayexjwr2llar">
                  {item.title}
                </h3>
                <p className="mt-4 max-w-xs font-serif text-xl italic leading-snug text-steel sm:text-[1.4rem]" data-id="element-20" data-mp="6t1ifktrx55x">
                  {item.text}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-21" data-mp="3ty0vtgzgzurp">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/121cf1c9-d8c2-4233-b486-cbb1f2793244.jpg" alt="Grupo de profesionales conversando en una sala de reuniones luminosa" className="mt-16 h-[300px] w-full object-cover sm:mt-20 sm:h-[460px]" data-id="element-22" data-mp="3tzbzlgsx12it" />
        </Reveal>
      </div>
    </section>;
}